module.exports = __webpack_public_path__ + "img/kakaclo.a3e347ce.png";